import { getStaticImageUrl } from '@utils/createImageUrl';

const ThirtyDay = ({ isMobile }: { isMobile?: boolean }) => {
  return (
    <div className="for-lawyer__thirty-day-content-container">
      <div className="for-lawyer__thirty-day-content">
        <div className="for-lawyer-dayplus-title view-on-visible">
          <h2 className="for-lawyer-day-title white">Day</h2>
          <span className="for-lawyer-day-plus-number-title">+30</span>
        </div>
        <p className="for-lawyer-day-desc white view-on-visible">
          한 달간 로톡을 해보니 잠재 의뢰인도 많고, 이용 방법도 편리해 나 같은 개업 변호사에게{' '}
          <span className="for-lawyer-day-desc-bold">최고의 마케팅 도구</span>라는 생각이 든다.
          <br />
          <br />
          광고 상품도 생각보다 합리적인 가격이라 분야 광고와 지역 광고 하나씩을 구매해보기로 했다.
        </p>
        <div className="for-lawyer-ad-type-img-container">
          <img
            className="for-lawyer-ad-type-img for-lawyer-ad-type-img-1 active"
            src={getStaticImageUrl({ fileName: 'preview/category-ad.png' })}
          />
          <img
            className="for-lawyer-ad-type-img for-lawyer-ad-type-img-2"
            src={getStaticImageUrl({ fileName: 'preview/location-ad.png' })}
          />
        </div>
        {isMobile && (
          <div className="for-lawyer__slide-circle-container">
            <div className="for-lawyer__slide-circle white active" />
            <div className="for-lawyer__slide-circle white" />
          </div>
        )}
      </div>
    </div>
  );
};

export default ThirtyDay;
